import React from "react"
import SearchableMultiSelectFilter from "../../base/SearchableMultiSelectFilter"
import { commonOptions } from "@shared/lib/filters/common-options"

interface StoreFiltersProps {
  storesValue?: string[]
  onStoresChange?: (value: string[] | null) => void
  className?: string
}

export const StoreFilters = ({
  storesValue = [],
  onStoresChange,
  className,
}: StoreFiltersProps) => {
  return (
    <SearchableMultiSelectFilter
      value={storesValue}
      onChange={onStoresChange}
      options={commonOptions.terminalStore}
      searchFields={['label']}
      displayTitle="Select Stores"
      searchPlaceholder="Search stores..."
      filterKey="store"
      filterLabel="Store"
      className={className}
    />
  )
}

export default React.memo(StoreFilters)